import React, { Fragment, useEffect, useState } from "react";
import PageHeader from "../../common/components/PageHeader";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { Add, FiberManualRecord } from "@mui/icons-material";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import Calendar from "../Dashboard/Calendar";
import RecentActivites from "./RecentActivities";
import ScoreBoard from "./ScoreBoard";
import { ExamType, ExamTypes, ServiceOffer, UserTypeId } from "../../common/const";
import Score from "./Score";
import Tutor from "./Tutor";
import CommonCard from "../../common/components/CommonCard";
import CoachTask from "./CoachTask";
import ScoreHistory from "./ScoreHistory";
import { useNavigate } from "react-router-dom";
import CurrentPlan from "../../common/components/CurrentPlan";
import ScoreDialog from "./ScoreDialog";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { getDashBoardDetails, getDashboardGraph, getStudentTestGoal } from "../../api/satactApi";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { checkBookingSession } from "../../api/sessionApi";

const SatActCoach = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [latestScore, setLatestScore] = useState(null);
    const [addOpen, setAddOpen] = useState(false);
    const [testType, setTestType] = useState(ExamType.SAT);
    const [assigned, setAssigned] = useState(null);
    const [mentorId, setMentorId] = useState(null);
    const [state, setState] = useState({
        series: [{
            name: testType,
            data: []
        }],
        options: {
            stroke: {
                width: 2, // Change this to make line smaller (default is 2, try 1 for thinner)
                curve: 'smooth' // Optional: 'straight' for straight lines
            },
            chart: {
                height: 350,
                type: 'line',
                zoom: {
                    enabled: false
                },
                toolbar: {
                    show: false,
                },
            },
            dataLabels: {
                enabled: true
            },
            xaxis: {
                categories: [],
            },
            grid: {
                borderColor: '#e7e7e7',
                strokeDashArray: 5,
                yaxis: {
                    lines: {
                        show: true // This shows horizontal grid lines
                    }
                },
                xaxis: {
                    lines: {
                        show: true // Hide vertical grid lines if you want
                    }
                }
            },
        },
    });
    const [coachData, setCoachData] = useState(null);

    const getHistoryData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getDashboardGraph(testType, user?.student_id);
            setState({
                series: [{
                    name: testType,
                    data: response.data?.map((a) => a.score)
                }],
                options: {
                    stroke: {
                        width: 2, // Change this to make line smaller (default is 2, try 1 for thinner)
                        curve: 'smooth' // Optional: 'straight' for straight lines
                    },
                    chart: {
                        height: 350,
                        type: 'line',
                        zoom: {
                            enabled: false
                        },
                        toolbar: {
                            show: false,
                        },
                    },
                    dataLabels: {
                        enabled: true
                    },
                    xaxis: {
                        categories: response.data?.map((a) => a.label),
                    },
                    grid: {
                        borderColor: '#e7e7e7',
                        strokeDashArray: 5,
                        yaxis: {
                            lines: {
                                show: true // This shows horizontal grid lines
                            }
                        },
                        xaxis: {
                            lines: {
                                show: true // Hide vertical grid lines if you want
                            }
                        }
                    },
                }
            });
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    const getScoreData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getDashBoardDetails(testType, user?.student_id);
            let data = response?.data?.latest;
            const goalResponse = await getStudentTestGoal(testType, user?.student_id);
            if (goalResponse.data?.length > 0) {
                data.goalData = goalResponse.data[0];
            }
            setLatestScore(data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    const checkSessionBook = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await checkBookingSession(ServiceOffer.coach, user?.student_id);
            setMentorId(response?.data?.mentor_profile_id);
            setAssigned(response?.data.type);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (user?.student_id) {
            getScoreData();
            getHistoryData();
            checkSessionBook();
        }
    }, [user, testType]);

    return (
        <Fragment>
            <PageHeader
                title="My DCP SAT/ACT Coach"
                content={
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography color="text.secondary" sx={{ fontSize: 14, }}>
                            My DCP Services
                        </Typography>
                        <FiberManualRecord sx={{ fontSize: 8, color: 'text.secondary' }} />
                        <Typography color="text.secondary" sx={{ fontSize: 14, }}>
                            My DCP SAT/ACT Coach
                        </Typography>
                    </Stack>
                }
            />
            <Grid container spacing={2}>
                <ScoreDialog
                    addOpen={addOpen}
                    setAddOpen={setAddOpen}
                    getScoreData={getScoreData}
                />
                <Grid item md={8} xs={12}>
                    <Box mt={2} display="flex" gap={1}>
                        <CommonButton
                            label={ExamType.SAT}
                            width="80px"
                            fontWeight={600}
                            color={testType === ExamType.SAT ? theme.palette.secondary.main : theme.palette.background.dark}
                            background={testType === ExamType.SAT ? theme.palette.primary.main : 'white'}
                            handleClick={() => setTestType(ExamType.SAT)}
                            marginBottom="0px"
                        />
                        <CommonButton
                            label={ExamType.ACT}
                            width="80px"
                            fontWeight={600}
                            color={testType === ExamType.ACT ? theme.palette.secondary.main : theme.palette.background.dark}
                            background={testType === ExamType.ACT ? theme.palette.primary.main : 'white'}
                            handleClick={() => setTestType(ExamType.ACT)}
                            marginBottom="0px"
                        />
                    </Box>
                    {latestScore && (
                        <Fragment>
                            <ScoreBoard testType={testType} latestScore={latestScore} />
                            <Tutor
                                testType={testType}
                                assigned={assigned}
                                coachData={coachData}
                                setCoachData={setCoachData}
                                mentorId={mentorId}
                            />
                            <CoachTask testType={testType} />
                            <ScoreHistory state={state} />
                        </Fragment>
                    )}
                </Grid>
                {latestScore && (
                    <Grid item xs={12} md={4} mt={2}>
                        <CurrentPlan
                            examType={ExamTypes.ACT_SAT}
                        />
                        <Score testType={testType} getScoreData={getScoreData} latestScore={latestScore} coachData={coachData} />
                        <Calendar fromSat={true} testType={testType} />
                        <RecentActivites testType={testType} />
                        {assigned === 'DISCOVERY' && (
                            <CommonCard
                                borderRadius={2}
                                background="#FFFCCF"
                                content={
                                    <Box display="flex" flexDirection="column" alignItems="center">
                                        <img src="/Images/coach.png" alt="coach" height="50px" />
                                        <Typography fontWeight={600} mt={1}>Need 1-on-1 Help?</Typography>
                                        <Typography fontSize={14} color={theme.palette.background.dark}>
                                            Get matched with a 99th percentile tutor for personalized strategy.
                                        </Typography>
                                        {user?.user_type_id === UserTypeId.Student &&
                                            (<CommonButton
                                                marginTop={2}
                                                label="Find a Coach"
                                                fontWeight={600}
                                                marginBottom="0px"
                                                handleClick={() => navigate('/book-session?type=coach')}
                                            />)}
                                    </Box>
                                }
                            />
                        )}
                        <CommonButton
                            marginTop={2}
                            label="Reach DCP Support Team"
                            fontWeight={600}
                            marginBottom="5px"
                            handleClick={() => navigate('/dcp-support')}
                        />
                        <Typography fontSize={14} color={theme.palette.background.dark}>Reach out to the DCP Support Team for quick help and personalized support - every step of the way.</Typography>
                    </Grid>
                )}
            </Grid>
            {!latestScore && (
                (
                    <Box
                        sx={{
                            mt: 2,
                            height: '73vh',
                            background: '#7A869126',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Typography color={theme.palette.background.dark}>You are not enrolled for</Typography>
                        <Typography color={theme.palette.background.dark}>SAT/ACT</Typography>
                        {user?.user_type_id === UserTypeId.Student && (
                            <CommonButton
                                label="Log New Score"
                                startIcon={<Add />}
                                fontWeight={600}
                                width="170px"
                                marginTop={1.5}
                                handleClick={() => setAddOpen(true)}
                            />)}
                    </Box>
                )
            )}
        </Fragment >
    )
}

export default SatActCoach;